import { render } from "./SubstitutesTreeView.vue?vue&type=template&id=23f7618f&scoped=true"
import script from "./SubstitutesTreeView.vue?vue&type=script&lang=js"
export * from "./SubstitutesTreeView.vue?vue&type=script&lang=js"

import "./SubstitutesTreeView.vue?vue&type=style&index=0&id=23f7618f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f7618f"]])

export default __exports__